/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { NotificationCategoryFromJSON, NotificationCategoryToJSON, } from './NotificationCategory';
/**
 * Check if a given object implements the UnsubscribeResponse interface.
 */
export function instanceOfUnsubscribeResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function UnsubscribeResponseFromJSON(json) {
    return UnsubscribeResponseFromJSONTyped(json, false);
}
export function UnsubscribeResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'category': !exists(json, 'category') ? undefined : NotificationCategoryFromJSON(json['category']),
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
    };
}
export function UnsubscribeResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'category': NotificationCategoryToJSON(value.category),
        'displayName': value.displayName,
    };
}
